import { Box, Checkbox, CircularProgress, Grid, Icon, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Table, TableBody, TableCell, TableRow, TextField, Tooltip } from "@mui/material"
import { useNavigate } from "react-router"
import { CustomButton } from "components/roundedbutton/CustomButton"
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import useCatchApiError from "hooks/useCatchApiError";
import FinancasService from "./financas.service";
import { FiltroAvancadoContaReceberDTO, FlowContaReceberDTO, StatusContaPagarReceber, TContaReceberCheckBox, TFiltroAvancadoOptions } from "./financas.model";

import { ColumnData, currencyOf, deepCopy, isAbertoOuParcial, isChecked, isEmpty, isParcialOuBaixado, resolveWrapper, toLocaleDateString } from "utils/util";
import VisualizarContaReceber from "./VisualizarContaReceber";
import BaixarContaReceber from "./BaixarContaReceber";
import { IAbstractModel } from "model/abstract.model";
import PagamentoService from "pages/pagamento/pagamento.service";
import FiltroAvancadoContasReceber from "./FiltroAvancadoContasReceber";
import RegistraVendaService from "pages/registra-venda/registra-venda.service";
import { TableVirtuosoHandle } from "react-virtuoso";
import { useAppSelector } from "redux/hooks";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import ExcluirContaReceber from "components/ExcluirContaReceber";
import { GenericTO } from "model/generic.model";
import FinancasGestaoReceberFloatingActions from "./FinancasGestaoReceberFloatingActions";
import { ROLES } from "roles/roles";
import InfiniteScrollVirtuoso, { HeaderExtraParams, HeaderInfiniteScrollVirtuoso, InfiniteScrollTableProps, RowInfiniteScrollVirtuosoProps } from "components/infinitescrollvirtuoso/InfiniteScrollVirtuoso";
import CustomRedExclamationIcon from "components/Icons/CustomRedExclamationIcon";
import File from "../../../src/components/Icons/File";
import BarCode from "components/Icons/BarCode";
import BarCodeChecked from "components/Icons/BarCodeChecked";
import FinancasIcon from "components/Icons/FinancasIcon";
import { theme } from "theme";

export type TItemFLowContaReceber = {
    __checkbox: unknown,
    __acoes: unknown,
    __vencido: unknown,
    __possuiVinculo: unknown,
    __parcelaBoletoGerado: unknown
}





const FinancasGestaoReceber = () => {
    const estabelecimentoSelecionado = useAppSelector(e => e.estabelecimentoSelecionado)

    const initialState = {
        filtroAvancadoContasReceber: {
            descricao: "",
            pessoa: null,
            numeroDocumentos: [],
            numeroParcela: "",
            emissao: {
                inicio: null,
                fim: null
            },
            vencimento: {
                inicio: null,
                fim: null
            },
            baixa: {
                inicio: null,
                fim: null
            },
            estabelecimentos: [estabelecimentoSelecionado],
            formasPagamento: [],
            statusParcela: [StatusContaPagarReceber.ABERTA, StatusContaPagarReceber.PARCIAL],
            filtroCartaoDTO: {
                nsus: [],
                numerosControle: []
            },
            filtroChequeDTO: {
                banco: null,
                agenciaCheque: null,
                numeroCheque: null,
                situacoesCheque: [],
                chequeComTerceiro: null
            },
            pageNumber: 1,
            pageSize: 20
        } as FiltroAvancadoContaReceberDTO,
        filtroAvancadoOptions: {
            pessoa: [],
            status: [
                StatusContaPagarReceber.ABERTA,
                StatusContaPagarReceber.PARCIAL,
                StatusContaPagarReceber.BAIXADA,
                StatusContaPagarReceber.CANCELADA
            ],
            bancos: [],
            situacoesCheque: []
        } as TFiltroAvancadoOptions,
        contasReceber: [] as Array<FlowContaReceberDTO>,
        isLoading: true,
        rowSelected: null as FlowContaReceberDTO | null,
        anchorEl: null as null | HTMLElement,
        filtroDescricao: "" as string,
        filtroParcela: "" as string,
        formasPagamento: [] as Array<IAbstractModel>,
        formasPagamentoSelecionado: [] as Array<IAbstractModel>,
        showVisualizarContaReceber: false as boolean,
        showBaixarContaReceber: false as boolean,
        showFiltroAvancado: false as boolean,
        contasReceberCount: 0 as number,
        selecionados: [] as Array<FlowContaReceberDTO>,
        showExcluir: false as boolean,
        contasFinanceiras: [] as Array<GenericTO>,
        openSpeedDial: false as boolean,
        toExcluir: [] as Array<string>
    }
    const navigate = useNavigate();
    const financasService = FinancasService()
    const pagamentoService = PagamentoService();
    const registraVendaService = RegistraVendaService();
    const { throwErrorMessage } = useCatchApiError();
    const { addSuccess, addError } = useSnackbarCustom()
    const [stateLocal, setStateLocal] = useState(initialState)
    const isFirstRender = useRef<boolean>(true)
    const keepSearching = useRef<boolean>(true)
    const uuidAnchorEl = useRef<string | null>(null)
    const canClickRef = useRef<boolean>(true)
    const { KEY_CLOAK_ROLES_SUBS, KEY_CLOAK_ROLES } = useAppSelector(e => e.token)

    const isDisabled = useCallback((item: FlowContaReceberDTO, uuidsSelecionados: Array<TContaReceberCheckBox>) => {
        if (item.status === StatusContaPagarReceber.BAIXADA || item.status === StatusContaPagarReceber.CANCELADA) return true
        if (item.formaPagamento === "CHEQUE" && !!item.parcelaBoletoGerado) return true
        if (!isEmpty(uuidsSelecionados) && item.modalidade !== uuidsSelecionados[0].modalidade) return true
        return false
    }, [])

    const isRemessaOuBoleto = useCallback((parcelaBoletoGerado: string) => {
        return parcelaBoletoGerado.includes("MODALIDADE")
        //eslint-disable-next-line
    }, [])

    const isChequeAberto = useCallback((item: FlowContaReceberDTO) => {
        return item.formaPagamento === "CHEQUE" && !!item.parcelaBoletoGerado
    }, [])

    const getIcon = useCallback((item: FlowContaReceberDTO) => {
        if (!item.parcelaBoletoGerado) return <></>
        if (isChequeAberto(item)) return <FinancasIcon color={theme.palette.primary.main} fontSize="18px" />
        if (isRemessaOuBoleto(item.parcelaBoletoGerado)) return <BarCodeChecked color={theme.palette.primary.main} fontSize="18px" />
        return <BarCode color={theme.palette.primary.main} />
        //eslint-disable-next-line
    }, [])

    const mainColumn: ColumnData<FlowContaReceberDTO & TItemFLowContaReceber>[] = useMemo(() => [
        {
            id: "checkbox",
            key: "__checkbox",
            header: "",
            type: "checkBox",
            width: 2.5,
            textAlign: "center",
            convert: (item, { extraData, column }) => {
                return (
                    <TableCell sx={{
                        border: 0,
                        padding: 0,
                        width: extraData.calcWidth(column.width),
                        textAlign: column.textAlign
                    }}>
                        <Tooltip title={item.modalidade !== null ? item.modalidade : "SEM MODALIDADE"}>
                            <Checkbox
                                onClick={() => onSelectUUID(stateLocal.selecionados, item)}
                                id={`item-${item.uuid}-input`}
                                sx={{
                                    '&.MuiCheckbox-root.Mui-checked': {
                                        color: theme.palette.primary.main,
                                        border: 0,
                                        padding: 0
                                    },
                                    border: 0,
                                    padding: 0.5,
                                }}
                                checked={isChecked(stateLocal.selecionados, item)}
                                disabled={isDisabled(item, stateLocal.selecionados)}
                                key={item.uuid}
                                value={item.uuid}
                            />
                        </Tooltip>
                    </TableCell>
                )
            }
        },
        {
            id: "vencido",
            key: "__vencido",
            header: "",
            type: "string",
            width: 2.5,
            textAlign: "center",
            convert: (item, { column, extraData }) => {
                return (
                    <Tooltip title={`CONTA VENCIDA`}>
                        <TableCell
                            sx={{
                                color: theme.palette.primary.main,
                                textAlign: "center",
                                padding: 0,
                                border: 0,
                                width: extraData.calcWidth(column.width),
                            }}
                        >

                            {item.vencido ? <CustomRedExclamationIcon /> : <></>}
                        </TableCell>
                    </Tooltip>

                )
            }
        },
        {
            id: "possuiVinculo",
            key: "__possuiVinculo",
            header: "",
            type: "checkBox",
            width: 2.5,
            textAlign: "center",
            convert: (item, { column, extraData }) => {
                return (
                    <Tooltip title={`ESSA CONTA A RECEBER POSSUI VINCULO COM NOTA FISCAL.\n ${item.possuiVinculo}`}>
                        <TableCell
                            sx={{
                                textOverflow: "ellipsis",
                                color: theme.palette.primary.main,
                                textAlign: column.textAlign,
                                padding: 0,
                                border: 0,
                                width: extraData.calcWidth(column.width)
                            }}
                        >
                            {item.possuiVinculo ? <File /> : <></>}
                        </TableCell>
                    </Tooltip>

                )
            }
        },
        {
            id: "parcelaBoletoGerado",
            key: "__parcelaBoletoGerado",
            header: "",
            type: "string",
            textAlign: "center",
            width: 2.5,
            convert: (item, { column, extraData }) => {
                return (
                    <Tooltip title={`${item.parcelaBoletoGerado}`}>
                        <TableCell
                            sx={{
                                textOverflow: "ellipsis",
                                color: theme.palette.error.main,
                                textAlign: "center",
                                padding: 0,
                                border: 0,
                                width: extraData.calcWidth(column.width)
                            }}
                        >
                            {getIcon(item)}
                        </TableCell>
                    </Tooltip>

                )
            }
        },
        {
            id: "descricao",
            key: "descricao",
            header: "Descrição",
            type: "string",
            width: 20,
            sortable: true,
            textAlign: "left",
            convert: (item, { column, extraData }) => {
                return (
                    <TableCell sx={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        minWidth: extraData.calcWidth(column.width),
                        maxWidth: extraData.calcWidth(column.width),
                        width: extraData.calcWidth(column.width),
                        padding: 0,
                        border: 0,
                    }}>
                        <Tooltip title={item.descricao}>
                            <TableCell sx={{
                                border: 0,
                                padding: 0
                            }}>
                                {item.descricao}
                            </TableCell>
                        </Tooltip>
                    </TableCell>
                )
            }
        },
        {
            id: "parcela",
            key: "parcela",
            header: "Parcela",
            type: "string",
            width: 5,
            sortable: true,
            textAlign: "center"
        },
        {
            id: "emissao",
            key: "emissao",
            header: "Emissão",
            type: "string",
            width: 7,
            sortable: true,
            textAlign: "center",
            convert: (item, { column, extraData }) => {
                return (
                    <TableCell
                        sx={{
                            textOverflow: "ellipsis",
                            textAlign: column.textAlign,
                            padding: 0,
                            border: 0,
                            minWidth: extraData.calcWidth(column.width),
                            maxWidth: extraData.calcWidth(column.width),
                            width: extraData.calcWidth(column.width)
                        }}
                    >
                        {toLocaleDateString(item.emissao)}
                    </TableCell>
                )
            }
        },
        {
            id: "vencimento",
            key: "vencimento",
            header: "Vencimento",
            type: "string",
            width: 7,
            sortable: true,
            textAlign: "center",
            convert: (item, { column, extraData }) => {
                return (
                    <TableCell
                        sx={{
                            textOverflow: "ellipsis",
                            padding: 0,
                            border: 0,
                            textAlign: column.textAlign,
                            minWidth: extraData.calcWidth(column.width),
                            maxWidth: extraData.calcWidth(column.width),
                            width: extraData.calcWidth(column.width)
                        }}
                    >
                        {toLocaleDateString(item.vencimento)}
                    </TableCell>
                )
            }
        },
        {
            id: "valor",
            key: "valor",
            header: "Valor",
            type: "number",
            width: 10,
            textAlign: "center",
            sortable: true,
            convert: (item, { extraData, column }) => {
                return (
                    <TableCell
                        key={item.uuid + item.emissao + '-row'}
                        sx={{
                            height: '30px',
                            fontSize: '14px',
                            padding: 0,
                            border: 0,
                            color: theme.palette.common.black,
                            borderBottom: "unset",
                            textAlign: column.textAlign,
                            minWidth: extraData.calcWidth(column.width),
                            maxWidth: extraData.calcWidth(column.width),
                            width: extraData.calcWidth(column.width)
                        }}
                    >
                        {currencyOf(item.valor)}
                    </TableCell>
                )
            }
        },
        {
            id: "valorAberto",
            key: "valorAberto",
            header: "Valor aberto",
            type: "number",
            width: 10,
            sortable: true,
            textAlign: "center",
            convert: (item, { extraData, column }) => {
                return (
                    <TableCell
                        key={item.uuid + item.emissao + '-row'}
                        sx={{
                            height: '30px',
                            fontSize: '14px',
                            padding: 0,
                            border: 0,
                            color: theme.palette.common.black,
                            borderBottom: "unset",
                            textAlign: column.textAlign,
                            minWidth: extraData.calcWidth(column.width),
                            maxWidth: extraData.calcWidth(column.width),
                            width: extraData.calcWidth(column.width)
                        }}
                    >
                        {currencyOf(item.valorAberto)}
                    </TableCell>
                )
            }
        },
        {
            id: "status",
            key: "status",
            header: "Status",
            type: "string",
            width: 10,
            sortable: true,
            textAlign: "center"
        },
        {
            id: "formaPagamento",
            key: "formaPagamento",
            header: "Forma de pagamento",
            type: "string",
            width: 15,
            textAlign: "center",
            sortable: true
        },
        {
            id: "acoes",
            key: "__acoes",
            header: "",
            type: "options",
            width: 5,
            convert: (item, { column, extraData }) => {
                return (
                    <TableCell
                        sx={{
                            textOverflow: "ellipsis",
                            color: theme.palette.common.black,
                            border: 0,
                            padding: 0,
                            textAlign: column.textAlign,
                            minWidth: extraData.calcWidth(column.width),
                            maxWidth: extraData.calcWidth(column.width),
                            width: extraData.calcWidth(column.width)
                        }}
                    >
                        <IconButton
                            onClick={(e) => onSetAnchorEl(e.currentTarget, item.uuid)}
                            style={{
                                position: 'relative',

                            }}
                        >
                            <Icon className="fa-solid fa-ellipsis-vertical" sx={{ width: "30px" }} />
                        </IconButton>
                        {uuidAnchorEl.current === item.uuid &&
                            <Menu key="vendas_table_menu"
                                anchorEl={stateLocal.anchorEl}
                                open={!!stateLocal.anchorEl}
                                onClose={() => onSetAnchorEl(null, null)}
                                sx={{ borderBottom: "1px solid black" }}
                            >
                                <MenuList>
                                    <MenuItem key={`visualizar-${item.uuid}`} disabled={!canVisualizar}
                                        onClick={clickVisualizar}>
                                        <ListItemIcon>
                                            <Icon className="fa-solid fa-eye" sx={{ fontSize: "18px", width: '20px' }} />
                                        </ListItemIcon>
                                        <ListItemText>Visualizar (Alt + V)</ListItemText>
                                    </MenuItem>

                                    {isAbertoOuParcial(item.status) && !isChequeAberto(item) && !item.descricao.toLowerCase().includes("recebimento da") &&
                                        <MenuItem key={`receber-${item.uuid}`} disabled={!canBaixar}
                                            onClick={onClickReceber}>
                                            <ListItemIcon>
                                                <Icon className="fa-solid fa-sack-dollar" sx={{ fontSize: "18px", width: '20px' }} />
                                            </ListItemIcon>
                                            <ListItemText>Receber (Alt + R)</ListItemText>
                                        </MenuItem>
                                    }

                                    {isParcialOuBaixado(item.status) &&
                                        <MenuItem key={`excluir-${item.uuid}`} disabled={!canExluir}
                                            onClick={() => onClickExcluir(item.uuid)}>
                                            <ListItemIcon>
                                                <Icon className="fa-solid fa-sack-dollar" sx={{ fontSize: "18px", width: '20px' }} />
                                            </ListItemIcon>
                                            <ListItemText>Excluir Recebimento (Alt + E)</ListItemText>
                                        </MenuItem>
                                    }
                                </MenuList>
                            </Menu>
                        }
                    </TableCell>
                )
            }
        },
        //eslint-disable-next-line
    ], [stateLocal.anchorEl, stateLocal.selecionados]);

    const handleKeysDown = (e: KeyboardEvent) => {
        if (stateLocal.showBaixarContaReceber || stateLocal.showExcluir ||
            stateLocal.showFiltroAvancado || stateLocal.showVisualizarContaReceber) return;
        if (e.altKey) {
            switch (e.code) {
                case "Space":
                    e.preventDefault();
                    onClickFloatingActions();
                    break;
                case "KeyF":
                    e.preventDefault();
                    onOpenFiltroAvancado();
                    break;
                case "KeyR":
                    const found = stateLocal.contasReceber.find(e => e.uuid === uuidAnchorEl.current)
                    if (found && (found.status === StatusContaPagarReceber.BAIXADA || found.status === StatusContaPagarReceber.CANCELADA)) {
                        setStateLocal(prevState => ({ ...prevState, anchorEl: null }))
                        return addError({ message: `Não é possível receber este conta receber pois seu status encontra-se ${found.status}` })
                    }
                    if (!canBaixar) {
                        setStateLocal(prevState => ({ ...prevState, anchorEl: null }))
                        return addError({
                            message: "Acesso não autorizado! Para acessar esta ação é necessário que o usuário tenha acesso de baixar contas a receber vinculado ao seu perfil.",
                            closeable: true,
                            preventDuplicate: true,
                            id: 'perfil_sem_acesso_receber'
                        })
                    }
                    const itemFound = stateLocal.contasReceber.find(e => e.uuid === uuidAnchorEl.current)

                    if (itemFound && isAbertoOuParcial(itemFound.status) && !isChequeAberto(itemFound) && itemFound.descricao.toLowerCase().includes("recebimento da")) {
                        addError({ message: `Não é possível receber este conta receber.` })
                        return setStateLocal(prevState => ({
                            ...prevState,
                            anchorEl: initialState.anchorEl
                        }))
                    }
                    e.preventDefault();
                    onClickReceber();
                    break;
                case "KeyL":
                    e.preventDefault();
                    resetFiltroAvancado();
                    break;
                case "KeyV":
                    if (!canVisualizar) {
                        setStateLocal(prevState => ({ ...prevState, anchorEl: null }))
                        return addError({
                            message: "Acesso não autorizado! Para acessar a ação de visualizar, é necessário que o usuário tenha acesso de consultar contas a receber vinculado ao seu perfil.",
                            closeable: true,
                            preventDuplicate: true,
                            id: 'perfil_sem_acesso_visualizar'
                        })
                    }
                    e.preventDefault();
                    clickVisualizar()
                    break;
                case "KeyE":
                    if (!canExluir) {
                        setStateLocal(prevState => ({ ...prevState, anchorEl: null }))
                        return addError({
                            message: "Acesso não autorizado! Para acessar esta ação é necessário que o usuário tenha acesso de excluir contas a receber vinculado ao seu perfil.",
                            closeable: true,
                            preventDuplicate: true,
                            id: 'perfil_sem_acesso_receber'
                        })
                    }
                    if (!uuidAnchorEl.current) {
                        return addError({
                            message: "Selecione ao menos uma conta.",
                            closeable: true,
                            preventDuplicate: true,
                            id: 'sem_uuid_selecionado_excluir_receber'
                        })
                    }
                    e.preventDefault();
                    onClickExcluir(uuidAnchorEl.current)
                    break;
            }
        }
        //eslint-disable-next-line
    }


    useEffect(() => {
        window.addEventListener('keydown', handleKeysDown);
        return () => {
            window.removeEventListener('keydown', handleKeysDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateLocal.selecionados, stateLocal.contasReceber, stateLocal.showFiltroAvancado]);


    const getFormasPagamento = useCallback(async () => {
        try {
            const { data } = await pagamentoService.getFormasPagamento();
            setStateLocal(prevState => ({
                ...prevState, formasPagamento: data,
                formasPagamentoSelecionado: data
            }))
        } catch (err) {
            throwErrorMessage(err ?? [])
        }
        //eslint-disable-next-line
    }, [])

    const getConsumidoresAc = useCallback(async (toSearch: string) => {
        try {
            const { data } = await registraVendaService.getConsumidoresAc(toSearch)
            setStateLocal(prevState => ({
                ...prevState, filtroAvancadoOptions: {
                    ...prevState.filtroAvancadoOptions,
                    pessoa: data
                }
            }))
        } catch (err) {
            throwErrorMessage(err ?? [])
        }
        //eslint-disable-next-line
    }, [])

    const getBancos = useCallback(async () => {
        try {
            const { data } = await pagamentoService.getBancos()
            setStateLocal(prevState => ({
                ...prevState,
                filtroAvancadoOptions: {
                    ...prevState.filtroAvancadoOptions,
                    bancos: data
                }
            }))
        } catch (err) {
            throwErrorMessage(err ?? [])
        }
        //eslint-disable-next-line
    }, [])

    const getContasFinanceiras = useCallback(async () => {
        try {
            const { data } = await financasService.listarContasFinanceiras()
            setStateLocal(prevState => ({
                ...prevState,
                contasFinanceiras: data
            }))
        } catch (err) {
            throwErrorMessage(err ?? [])
        }
        //eslint-disable-next-line
    }, [])


    const fetchContasReceber = useCallback(async (filtro: FiltroAvancadoContaReceberDTO, scrolling: boolean, count: number) => {
        if (!scrolling) {
            setStateLocal(prevState => ({ ...prevState, isLoading: true }))
        }
        keepSearching.current = false

        try {
            const { data } = await financasService.getContasReceber(filtro)

            if (data.length === 20) keepSearching.current = true
            canClickRef.current = true

            setStateLocal(prevState => ({
                ...prevState,
                isLoading: false,
                contasReceber: scrolling ? [...prevState.contasReceber, ...data] : data,
                contasReceberCount: count
            }))
        }
        catch (err) {
            canClickRef.current = true
            setStateLocal(prevState => ({ ...prevState, isLoading: false }))
            throwErrorMessage(err ?? [])
        }
        //eslint-disable-next-line
    }, []);

    const fetchCountContasReceber = useCallback(async (filtro: FiltroAvancadoContaReceberDTO) => {
        try {
            const { data } = await financasService.countContasReceber(filtro)
            return data
        } catch (err) {
            return 0
        }
        //eslint-disable-next-line
    }, [])


    useEffect(() => {
        if (isFirstRender.current) {
            fetchData(initialState.filtroAvancadoContasReceber)
            getFormasPagamento()
            getConsumidoresAc("")
            getBancos()
            getContasFinanceiras()
        }
        isFirstRender.current = false
        //eslint-disable-next-line
    }, [])

    const fetchData = useCallback(async (filtroAvancado: FiltroAvancadoContaReceberDTO) => {
        const count = await fetchCountContasReceber(filtroAvancado)
        fetchContasReceber(filtroAvancado, false, count)
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (!isFirstRender.current) {
            getFormasPagamento()
            getConsumidoresAc("")
            getBancos()
            fetchData(initialState.filtroAvancadoContasReceber)
        }
        isFirstRender.current = false
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado])

    const onSetAnchorEl = useCallback((e: EventTarget & HTMLButtonElement | null, uuid: string | null) => {
        setStateLocal(prevState => ({ ...prevState, anchorEl: e }))
        uuidAnchorEl.current = uuid;
    }, [])

    const canVisualizar = useMemo(() => {
        return KEY_CLOAK_ROLES_SUBS.includes(ROLES.CONTA_RECEBER_CONSULTAR) || KEY_CLOAK_ROLES.includes(ROLES.ADMIN) || KEY_CLOAK_ROLES.includes(ROLES.SUPER);
        //eslint-disable-next-line
    }, []);

    const canBaixar = useMemo(() => {
        return KEY_CLOAK_ROLES_SUBS.includes(ROLES.CONTA_RECEBER_BAIXAR) || KEY_CLOAK_ROLES.includes(ROLES.ADMIN) || KEY_CLOAK_ROLES.includes(ROLES.SUPER);
        //eslint-disable-next-line
    }, []);

    const canExluir = useMemo(() => {
        return KEY_CLOAK_ROLES_SUBS.includes(ROLES.CONTA_RECEBER_EXCLUIR_BAIXA) || KEY_CLOAK_ROLES.includes(ROLES.ADMIN) || KEY_CLOAK_ROLES.includes(ROLES.SUPER);
        //eslint-disable-next-line
    }, []);

    const clickVisualizar = useCallback(() => {
        if (isEmpty(stateLocal.selecionados) && !uuidAnchorEl.current) {
            setStateLocal(prevState => ({ ...prevState, anchorEl: null }))
            return addError({
                message: "Selecione uma conta.",
                closeable: true,
                persist: false
            })
        }
        if (stateLocal.selecionados.length > 1 && !uuidAnchorEl.current) {
            return addError({
                message: "Apenas uma conta pode ser selecionada.",
                closeable: true,
                persist: false
            })
        }
        if (stateLocal.selecionados.length === 1 && !uuidAnchorEl.current) {
            uuidAnchorEl.current = stateLocal.selecionados[0].uuid
        }

        setStateLocal(prevState => ({
            ...prevState,
            showVisualizarContaReceber: true,
            anchorEl: null
        }))
        //eslint-disable-next-line
    }, [stateLocal.selecionados])

    const onClickReceber = useCallback(() => {
        if (isEmpty(stateLocal.selecionados) && !uuidAnchorEl.current) {
            setStateLocal(prevState => ({ ...prevState, anchorEl: null }))
            return addError({
                message: "Selecione ao menos uma conta.",
                closeable: true,
                persist: false
            })
        }
        return setStateLocal(prevState => ({
            ...prevState,
            showBaixarContaReceber: true,
            anchorEl: null
        }))
        //eslint-disable-next-line
    }, [stateLocal.selecionados])

    const virtuosoRef = useRef<TableVirtuosoHandle>(null)

    const onScroll = useCallback((event: any) => {
        const scrollableElement = event.target as HTMLDivElement;
        const { scrollTop, scrollHeight, clientHeight } = scrollableElement;

        const scrolledPercentage = scrollTop / (scrollHeight - clientHeight);
        if (scrolledPercentage >= 0.65 && keepSearching.current) {
            setStateLocal(prevState => ({
                ...prevState,
                filtroAvancadoContasReceber: {
                    ...prevState.filtroAvancadoContasReceber,
                    pageNumber: prevState.filtroAvancadoContasReceber.pageNumber + 1
                }
            }))

            const filtro = deepCopy(stateLocal.filtroAvancadoContasReceber)
            filtro.pageNumber = filtro.pageNumber + 1
            fetchContasReceber(filtro, true, stateLocal.contasReceberCount)
        }
        //eslint-disable-next-line
    }, [stateLocal.filtroAvancadoContasReceber, stateLocal.contasReceberCount])



    const onResetFiltroPessoa = useCallback(() => {
        getConsumidoresAc("")
        //eslint-disable-next-line
    }, [])

    const onConsultar = useCallback(async (filtroAvancado: FiltroAvancadoContaReceberDTO) => {
        if (!canClickRef.current) return;
        canClickRef.current = false
        virtuosoRef.current?.scrollToIndex({
            index: 0,
            align: "start",
            behavior: "smooth"
        })
        const filtroCopy = deepCopy(filtroAvancado)
        filtroCopy.descricao = filtroAvancado.descricao.trim()
        filtroCopy.pageNumber = 1
        setStateLocal(prevState => ({
            ...prevState,
            filtroAvancadoContasReceber: filtroCopy,
            showFiltroAvancado: false,
            isLoading: true
        }))
        const count = await fetchCountContasReceber(filtroCopy)
        fetchContasReceber(filtroCopy, false, count)
        //eslint-disable-next-line
    }, [])

    let consumidoresAcTimeout = useRef<NodeJS.Timeout | number>(0);

    const onInputChangePessoa = useCallback((value: string) => {
        clearTimeout(consumidoresAcTimeout.current)
        consumidoresAcTimeout.current =
            setTimeout(() => {
                getConsumidoresAc(value)
            }, 300);
        //eslint-disable-next-line
    }, [])

    const onOpenFiltroAvancado = useCallback(() => {
        setStateLocal(prevState => ({
            ...prevState,
            showFiltroAvancado: !prevState.showFiltroAvancado,
            anchorEl: null
        }))
    }, [])

    const onCloseFiltroAvancado = useCallback(() => {
        setStateLocal(prevState => ({
            ...prevState,
            showFiltroAvancado: false
        }))
    }, [])


    const fixedHeaderContent = useMemo(() => (tableProps: InfiniteScrollTableProps & HeaderExtraParams) => {
        return (
            <HeaderInfiniteScrollVirtuoso
                {...tableProps}
                columns={mainColumn}
            />
        )
        //eslint-disable-next-line
    }, [])

    const fixedFooterContent = useCallback((t: InfiniteScrollTableProps & {
        data: FlowContaReceberDTO[];
    }) => {
        return (
            <TableCell colSpan={999} className="glassmorphism"
                sx={{
                    bgcolor: 'transparent',
                    opacity: 0.9,
                    fontWeight: '600',
                    fontSize: '16px',
                    padding: 0,
                    height: "50px",
                    color: theme.palette.common.black,
                    alignSelf: "center",
                    textAlign: "center",
                    width: t.calcWidth(100)
                }}>
                {stateLocal.contasReceber.length} de {stateLocal.contasReceberCount} registros encontrados
            </TableCell>
        );
    }, [stateLocal.contasReceber, stateLocal.contasReceberCount]);

    const onSelectUUID = useCallback((uuidsSelecionados: Array<FlowContaReceberDTO>, checkbox: FlowContaReceberDTO) => {
        const isItemInArray = isChecked(uuidsSelecionados, checkbox)

        const uuidsRestantes = isItemInArray
            ? uuidsSelecionados.filter(e => e.uuid !== checkbox.uuid)
            : [...uuidsSelecionados, checkbox]

        setStateLocal(prevState => ({
            ...prevState,
            selecionados: uuidsRestantes
        }))
        //eslint-disable-next-line
    }, [])

    const onClickExcluir = useCallback((uuid: string) => {
        uuidAnchorEl.current = uuid;
        setStateLocal(prevState => ({ ...prevState, showExcluir: true, anchorEl: null }))
    }, [])

    const onExcluir = useCallback(async (selecionados: Array<string>) => {
        setStateLocal(prevState => ({ ...prevState, isLoading: true, anchorEl: initialState.anchorEl, showExcluir: false }))
        try {
            const response = await financasService.excluirBaixa(uuidAnchorEl.current!, selecionados)
            if (response.status === 204) {
                setStateLocal(prevState => ({
                    ...prevState,
                    isLoading: false,
                    selecionados: initialState.selecionados
                }))
                addSuccess({
                    message: "Exclusão do recebimento realizada com sucesso.",
                    id: "exclusao_recebimento_sucesso",
                    closeable: true,
                    preventDuplicate: true,
                    persist: false
                })
                uuidAnchorEl.current = null;
                onConsultar(stateLocal.filtroAvancadoContasReceber)
            }

        } catch (err) {
            uuidAnchorEl.current = null;
            setStateLocal(prevState => ({ ...prevState, isLoading: false, selecionados: initialState.selecionados }))
            throwErrorMessage(err ?? [])
        }
        //eslint-disable-next-line
    }, [stateLocal.filtroAvancadoContasReceber])

    const onCloseVisualizar = useCallback(() => {
        uuidAnchorEl.current = null;
        return setStateLocal(prevState => ({
            ...prevState,
            showVisualizarContaReceber: false,
            selecionados: initialState.selecionados
        }))
        //eslint-disable-next-line
    }, [])

    const onClickFloatingActions = useCallback(() => {
        return setStateLocal(prevState => ({
            ...prevState,
            openSpeedDial: !prevState.openSpeedDial
        }))
    }, [])

    const onCloseReceber = useCallback(() => {
        uuidAnchorEl.current = null;
        return setStateLocal(prevState => ({
            ...prevState,
            showBaixarContaReceber: false,
            selecionados: initialState.selecionados
        }))
        //eslint-disable-next-line
    }, [])

    const onCloseExluir = useCallback(() => {
        uuidAnchorEl.current = null;
        return setStateLocal(prevState => ({
            ...prevState,
            showExcluir: initialState.showExcluir,
            selecionados: initialState.selecionados
        }))
        //eslint-disable-next-line
    }, [])

    const onSelectUUIDToExcluir = useCallback((arrToExcluir: Array<string>, uuidToExcluir: string) => {
        const isItemInArray = isChecked(arrToExcluir, uuidToExcluir)

        const updatedArray = isItemInArray
            ? arrToExcluir.filter(e => e !== uuidToExcluir)
            : [...arrToExcluir, uuidToExcluir]

        setStateLocal(prevState => ({ ...prevState, toExcluir: updatedArray }))
    }, [])

    const onCloseReturning = useCallback((baixados: Array<FlowContaReceberDTO>) => {
        uuidAnchorEl.current = null;
        const baixadosMap = new Map(baixados.map(b => [b.uuid, b.status]));

        setStateLocal(prevState => ({
            ...prevState,
            contasReceber: prevState.contasReceber.map(conta => {
                if (baixadosMap.has(conta.uuid)) {
                    return { ...conta, status: baixadosMap.get(conta.uuid)! };
                }
                return conta;
            }),
            showBaixarContaReceber: false,
            selecionados: []
        }));
        if (isEmpty(baixados)) return

        if (baixados.length === 1) {
            addSuccess({
                message: "Baixa realizada com sucesso.",
                id: "exclusao_recebimento_sucesso",
                closeable: true,
                preventDuplicate: true,
                persist: false
            })
        } else {
            addSuccess({
                message: "Baixas realizadas com sucesso.",
                id: "exclusao_recebimento_sucesso_multiplo",
                closeable: true,
                preventDuplicate: true,
                persist: false
            })
        }
        setTimeout(() => {
            resetFiltroAvancado()
        }, 300);
        // onConsultar(stateLocal.filtroAvancadoContasReceber)
        //eslint-disable-next-line
    }, [stateLocal.filtroAvancadoContasReceber]);

    const TableCustomRow = ({ calcWidth, columns, data, index }: RowInfiniteScrollVirtuosoProps<FlowContaReceberDTO, FlowContaReceberDTO & TItemFLowContaReceber>) => {
        return (
            <TableCell
                colSpan={999}
                style={{
                    padding: 0,
                }}
            >
                <Table>
                    <TableBody>
                        <TableRow>
                            {columns.map((col, indexCol) => {
                                return <TableCell
                                    key={col.key + index + indexCol + '-row'}
                                    sx={{
                                        height: '30px',
                                        minWidth: calcWidth(col.width),
                                        maxWidth: calcWidth(col.width),
                                        width: calcWidth(col.width),
                                        textAlign: col.textAlign,
                                        fontSize: '14px',
                                        color: theme.palette.common.black,
                                        padding: 0,
                                        border: 0
                                    }}
                                >
                                    {(col.convert?.(data as any, { column: col, extraData: { calcWidth } })) ?? resolveWrapper(data, col.key)}
                                </TableCell>
                            })}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableCell>
        );
    }



    const removeFormaPagamentoChip = useCallback((formasPagamentoRestantes: Array<IAbstractModel>) => {
        setStateLocal(prevState => ({
            ...prevState,
            filtroAvancadoContasReceber: {
                ...prevState.filtroAvancadoContasReceber,
                formasPagamento: formasPagamentoRestantes
            }
        }))
    }, [])


    let fetchDataRef = useRef<NodeJS.Timeout | number>(0);

    const onChangeFiltroDescricao = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        clearTimeout(fetchDataRef.current)
        setStateLocal(prevState => ({
            ...prevState,
            filtroAvancadoContasReceber: {
                ...prevState.filtroAvancadoContasReceber,
                descricao: e.target.value,
                pageNumber: initialState.filtroAvancadoContasReceber.pageNumber
            },
            isLoading: true
        }))
        const copy = deepCopy(stateLocal.filtroAvancadoContasReceber)
        copy.descricao = e.target.value.trim()
        copy.pageNumber = 1
        fetchDataRef.current = setTimeout(async () => {
            if (virtuosoRef.current !== null) {
                virtuosoRef.current.scrollToIndex({
                    index: 0,
                    align: "start",
                    behavior: "smooth"
                });
            }
            const count = await fetchCountContasReceber(copy)
            fetchContasReceber(copy, false, count)
        }, 300);
        //eslint-disable-next-line
    }, [stateLocal.filtroAvancadoContasReceber])

    const resetFiltroAvancado = useCallback(() => {
        keepSearching.current = false;
        uuidAnchorEl.current = null
        if (virtuosoRef.current !== null) {
            virtuosoRef.current.scrollToIndex({
                index: 0,
                align: "start",
                behavior: "smooth"
            });
        }
        setStateLocal(prevState => ({
            ...prevState,
            filtroAvancadoContasReceber: initialState.filtroAvancadoContasReceber,
            isLoading: true,
            selecionados: initialState.selecionados,
            anchorEl: null,
        }))
        setTimeout(async () => {
            const count = await fetchCountContasReceber(initialState.filtroAvancadoContasReceber)
            fetchContasReceber(initialState.filtroAvancadoContasReceber, false, count)
        }, 500);
        //eslint-disable-next-line
    }, [])

    return (
        <Grid container sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: "center",
            height: "70vh"
        }}>
            <Box sx={{
                width: "90vw",
            }}>
                <TextField variant="standard" sx={{ width: '100%', marginBottom: '20px' }}
                    inputProps={{ maxLength: 200, id: "filtro-descricao-nome-numero" }}
                    value={stateLocal.filtroAvancadoContasReceber.descricao}
                    onChange={(e) => onChangeFiltroDescricao(e)}
                    label="Descrição, nome do cliente ou número do documento"
                />
                <InfiniteScrollVirtuoso
                    ref={virtuosoRef}
                    data={stateLocal.contasReceber}
                    renderItem={(tableProps) => TableCustomRow({ ...tableProps, columns: mainColumn, })}
                    heightScale={0.5}
                    fixedHeaderContent={fixedHeaderContent}
                    fixedFooterContent={fixedFooterContent}
                    key="financas-gestao-receber-key"
                    onScroll={onScroll}
                    initialSort={{
                        orderBy: 'emissao',
                        orderDirection: 'DESC'
                    }}

                // getRef={getRef}
                />


                <TableRow sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'absolute',
                    top: '50%',
                    left: 0,
                }}
                    key="sem_pedidos_table_row_error"
                >
                    {stateLocal.isLoading &&
                        <CircularProgress
                            size={48}
                            color='primary'
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                marginTop: '-12px',
                                marginLeft: '-12px',
                            }}
                        />
                    }
                    {!stateLocal.isLoading && isEmpty(stateLocal.contasReceber) &&
                        <TableCell
                            key="row_sem_pedidos_table_cell_error"
                            colSpan={11}
                            sx={{
                                fontSize: '48px',
                                color: theme.palette.text.primary,
                                border: 0,
                                padding: 0,
                                userSelect: 'none'
                            }}>
                            Não há contas receber no período informado.
                        </TableCell>
                    }
                </TableRow>
            </Box>
            <Grid item
                sx={{
                    marginTop: "50px",
                    width: '80%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                    height: "50px",
                }}
            >

                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="voltar-configuracao-vale-presente-btn"
                    onClick={() => navigate(-1)}
                    variant="contained"
                    color="error"
                    startIcon={<Icon className='fa-solid fa-arrow-left' />}>
                    Voltar
                </CustomButton>

                <FinancasGestaoReceberFloatingActions
                    open={stateLocal.openSpeedDial}
                    onClick={onClickFloatingActions}
                    onOpenFiltroAvancado={onOpenFiltroAvancado}
                    onClickReceber={onClickReceber}
                    onResetFiltro={resetFiltroAvancado}
                    canVisualizar={canVisualizar}
                    canBaixar={canBaixar}
                    canExcluir={canExluir}
                />

            </Grid>

            {stateLocal.showVisualizarContaReceber && uuidAnchorEl.current &&
                <VisualizarContaReceber
                    onClose={onCloseVisualizar}
                    uuid={uuidAnchorEl.current}
                />
            }

            {stateLocal.showBaixarContaReceber &&
                <BaixarContaReceber
                    onClose={onCloseReceber}
                    onCloseReturning={onCloseReturning}
                    uuid={uuidAnchorEl.current}
                    uuids={stateLocal.selecionados}
                    contasFinanceiras={stateLocal.contasFinanceiras}
                />
            }

            {stateLocal.showExcluir && uuidAnchorEl.current &&
                <ExcluirContaReceber
                    onClose={onCloseExluir}
                    uuid={uuidAnchorEl.current}
                    selecionados={stateLocal.toExcluir}
                    onSelectUUID={onSelectUUIDToExcluir}
                    onExcluir={onExcluir}
                />
            }

            {stateLocal.showFiltroAvancado &&
                <FiltroAvancadoContasReceber
                    filtroAvancado={stateLocal.filtroAvancadoContasReceber}
                    filtroAvancadoOptions={stateLocal.filtroAvancadoOptions}
                    onInputChangePessoa={onInputChangePessoa}
                    onResetFiltroPessoa={onResetFiltroPessoa}
                    onConsultar={onConsultar}
                    filtroDescricao={stateLocal.filtroDescricao}
                    filtroParcela={stateLocal.filtroParcela}
                    formasPagamento={stateLocal.formasPagamento}
                    formasPagamentoSelecionado={stateLocal.formasPagamentoSelecionado}
                    onClose={onCloseFiltroAvancado}
                    onRemoveFormaPagamentoChip={removeFormaPagamentoChip}

                />
            }
        </Grid >
    )
}

export default FinancasGestaoReceber
